<template>
  <Wrapper
    v-show="
      component && !preview && renderTools && widgetActive.id &&
      ![
        'reheight_widget',
        'remargin_widget',
        'crop_image',
        'sort_widget',
      ].includes(mode)
    "
    :class="{
      'top': !isOverScroll && (!isFirstSection || !oversection), 
      'bottom': isOverScroll || (isFirstSection && oversection), 
      [`widget-active-frame-${widgetActive.theme}`]: Boolean(widgetActive.theme) 
    }"
    id="widget-active-frame"
    :position="elemWidgetActive.params.position"
    :isActiveWidget="isActiveWidget"
    @click.stop.prevent
  >
    <!-- <WidgetHover class="active lbl-name p-0">
      <b-dropdown :dropup="!isOverScroll" :dropdown="isOverScroll" :class="{'top': !isOverScroll, 'bottom': isOverScroll}">
        <template #button-content>
          {{ widgetTypeShow }} <i class="fas" :class="{'fa-caret-up': !isOverScroll, 'fa-caret-down': isOverScroll}"></i>
        </template>
        <b-dropdown-item @click="goTo('section')">Section</b-dropdown-item>
        <b-dropdown-item @click="goTo('grid')">Grid</b-dropdown-item>
        <b-dropdown-item @click="goTo('cell')">Cell</b-dropdown-item>
      </b-dropdown>
    </WidgetHover> -->
    <WidgetHover 
      id="widget-active-label"
      :class="{
        'lbl-name' : isHeaderWidgetOnTopBar,
        'label-name-frame' : !isHeaderWidgetOnTopBar,
        'disabled': isLabelDisabled,
        'active': isLabelActive
      }"
      :style="{'left': isWidgetOverlap ? indexCell == 0 ? '106px' : isSlideContainerWidget ? '86px' : '54px' : '0px'}"
      >
      {{ widgetTypeShow }}
    </WidgetHover>

    <!-- Toolbar -->
    <WidgetTool 
      v-if="component && widgetActive.toolbarEnable && mode != 'resizing' && !hideTool" 
      id="widget-tool" 
      class="d-flex align-items-center widget-tool" 
      style="z-index: 5;"
      :marginHeight="component.style[attr] ? component.style[attr] : 0"
      :positionTool="positionTool"
    >
      <b-badge id="widget-tool-badge"
        v-if="!((getDynamicComponent == undefined) && isSystemWidget)"
        pill
        variant="light"
        class="d-flex align-items-center mb-10 my-2"
        :class="{'top': !isOverScroll && (!isFirstSection || !oversection), 'bottom': isOverScroll || (isFirstSection && oversection), 'header-widget': isHeaderWidget}"
      >
        <component
          :v-if="getDynamicComponent"
          :component="component"
          :is="getDynamicComponent"
          @callbackResize="callbackResize"
        />
        <!-- <div v-b-tooltip.hover title="link widget" class="ml-2 cursor-pointer">
          <i class="fas fa-link"></i>
        </div> -->
        <div class="cursor-pointer btn-tool"
          v-show="!isSystemWidget && !(detectDevice === 'mobile' && typeNotShowTrash.includes(widgetTypeShow)) && !isHeaderWidget && !isFooterWidget && !ignoreCentralDelete && detectDevice !== 'mobile' && !isWidgetButtonInGroup"
          @click="duplicateWidget()"
          :title="$t('engine.floatframeTool.btnHover.tooltip.lblDuplicate', languageEngine)"
          v-b-tooltip.hover 
        >
          <i class="far fa-clone" style="width: 15px; height: 15px"></i>
        </div>
        <div
          v-show="!isSystemWidget && !(detectDevice === 'mobile' && typeNotShowTrash.includes(widgetTypeShow)) && !isHeaderWidget && !isFooterWidget && !ignoreCentralDelete && detectDevice !== 'mobile' && !isWidgetButtonInGroup"
          @click="removeWidget"
          v-b-tooltip.hover
          :title="$t('engine.floatframeTool.btnHover.tooltip.lblRemove',languageEngine)"
          class="cursor-pointer btn-tool"
        >
          <i class="far fa-trash-alt" style="width: 15px; height: 15px"></i>
        </div>
      </b-badge>
    </WidgetTool>

    <!-- AI Tool Badge + Option Dropdown -->
    <AIToolBadge
      v-if="isShowAITool"
      :key="isAIToolActive"
      :show-badge="permissionDesignAI && isEnableAI && component && widgetActive.toolbarEnable && mode != 'resizing' && !hideTool && detectDevice !== 'mobile'"
      :isAIToolActive="isAIToolActive"
      :aiToolBadgeComputedStyle="aiToolBadgeComputedStyle"
      :show-dropdown="isAIToolActive && !isAIGenerateModalVisible"
      :positionAIOptionTool="positionAIOptionTool"
      :aiOptionItems="aiOptionItems"
      @badge-click="openAITool"
      @option-click="handleAIOptionClick"
      @submenu-click="handleAISubmenuClick"
    />

    <!-- AI Generate Modal (outside WidgetTool, inside Wrapper — same pattern as Toolbar in Quill.vue) -->
    <AIGenerate
      v-if="isAIGenerateModalVisible && permissionCurrency"
      ref="aiGenerateModal"
      class="ai-generate-modal-tool"
      :position="widgetActive.aiGenerateModalPosition"
      :actionContext="aiGenerateActionContext"
      :originalText="getWidgetOriginalText"
      :visible="isAIGenerateModalVisible"
      @apply="handleAIApply"
      @close="closeAIGenerateModal"
      @position-change="handleAIModalPositionChange"
    />

    <WidgetHover 
      v-if="getDynamicComponentTool"
      id="widget-active-tool"
      class="active"
      :class="{'lbl-name' : isHeaderWidgetOnTopBar ,'label-name-frame' : !isHeaderWidgetOnTopBar, }"
      style="left: 100%; transform: translate(-100%); padding : 0; width:auto; height :auto;"
    >
      <component
        v-if="getDynamicComponentTool"
        :component="component"
        :is="getDynamicComponentTool"
        @callbackResize="callbackResize"
      />
    </WidgetHover>


    <!-- <ImageResize
      v-if="resizeable"
      @callbackResize="callbackResize"
      :component="component"
    /> -->

    <MapResize
      v-if="widgetTypeShow === 'Map'"
      @callbackResize="callbackResize"
      :component="component"
    />

    <LineSeparateResize
      v-if="widgetTypeShow === 'Line'"
      @callbackResize="callbackResize"
      :component="component"
    />

    <!-- Reheight -->
    <Reheight v-if="checkShowReHeight" :component_id="component.id" />
    <!-- ResizeDot -->
    <component
      v-if="widgetActive.resizeDotEnable"
      :is="getDynamicResizeDot"
      :component="component" 
    />

  </Wrapper>
</template>

<script>
import { WidgetHover } from "./WidgetHover.styled";
import { WidgetTool, Wrapper } from "./WidgetActive.styled";
// import ImageResize from "../Image/tool/ImageResize.vue";
import LineSeparateResize from "../LineSeparate/tool/LineSeparateResize";
import MapResize from "../Map/tool/MapResize";
import Reheight from "@components/dynamic/widget/Share/Reheight";
import AIToolBadge from "@components_system/Design/AIGenerate/AIToolBadge";
import AIGenerate from "@components_system/Design/AIGenerate/AIGenerate";
import { getAIOptionsByContext, getContextByWidgetType } from "@model/aiOption.model";
import { mapGetters } from "vuex";
import { findParentComponent } from "@helpers/component.helper";
import { WIDGET, SYSTEM_WIDGET, HEADER_WIDGET, FOOTER_WIDGET, SECTION_TYPE_NONE_SETTING } from "@model/components/componentMeta.model";

const components = {
  // unit widget
  [WIDGET.prefixType + "IMAGE_TOOL"]: () =>
    import("@components/dynamic/widget/Image/tool/ImageTool"),
  [WIDGET.prefixType + "FORM_TOOL"]: () =>
    import("@components/dynamic/widget/Form/tool/FormTool"),
  [WIDGET.prefixType + "ICON_TOOL"]: () =>
    import("@components/dynamic/widget/Icon/tool/IconTool"),
  [WIDGET.prefixType + "YOUTUBE_TOOL"]: () =>
    import("@components/dynamic/widget/Youtube/tool/ImageTool"),
  [WIDGET.prefixType + "LINE_SEPARATE_TOOL"]: () =>
    import("@components/dynamic/widget/LineSeparate/tool/LineSeparateTool"),
  [WIDGET.prefixType + "SOCIAL_TOOL"]: () =>
    import("@components/dynamic/widget/Social/tool/SocialTool"),
  [WIDGET.prefixType + "INTERACTIVE_TOOL"]: () =>
    import("@components/dynamic/widget/Interactive/tool/InteractiveTool.vue"),
  [WIDGET.prefixType + "TEXT_TOOL"]: () =>
    import("@components/dynamic/widget/Text/Tools/Tool"),
  [WIDGET.prefixType + "IMAGE_GALLERY_TOOL"]: () =>
    import("@components/dynamic/widget/ImageGallery/tool/AddImage"),
  [WIDGET.prefixType + "PRODUCT_BRAND_TOOL"]: () =>
    import("@components/dynamic/widget/ProductBrand/tool/addBrands"),
  [WIDGET.prefixType + "BUTTON_TOOL"]: () =>
    import("@components/dynamic/widget/Button/tool/ButtonTool"),

  [WIDGET.prefixType + "COUNTER_TOOL"]: () =>
    import("@components/dynamic/widget/Counter/tool/CounterTool"),
  [WIDGET.prefixType + "CONTACT_TOOL"]: () =>
    import("@components/dynamic/widget/Contact/tool/ContactTool"),
  [WIDGET.prefixType + "MAP_TOOL"]: () =>
    import("@components/dynamic/widget/Map/tool/MapTool"),
  [WIDGET.prefixType + "HTML_TOOL"]: () =>
    import("@components/dynamic/widget/Html/tool/HtmlTool"),
  [WIDGET.prefixType + "TABLE_TOOL"]: () =>
    import("@components/dynamic/widget/Table/tool/TableTool"),
  // [WIDGET.prefixType + "TIKTOK_TOOL"]: () =>
  //   import("@components/dynamic/widget/Tiktok/tool/TiktokTool"),
  // [WIDGET.prefixType + "MENU_PRODUCT_TOOL"]: () =>
  //   import("@components/dynamic/widget/MenuProduct/tool/MenuProductTool"),

  [SYSTEM_WIDGET.prefixType + "TEXT_TOOL"]: () =>
    import("@components/dynamic/widget/Text/Tools/Tool"),
  [SYSTEM_WIDGET.prefixType + "IMAGE_TOOL"]: () =>
    import("@components/dynamic/widget/SystemImage/tool/ImageTool"),
  [HEADER_WIDGET.prefixType + "MENU_TOOL"]: () =>
    import("@components/header/widget/header_widget_menu/tool/HeaderMenuTool"),
  [HEADER_WIDGET.prefixType + "LOGO_TOOL"]: () =>
    import("@components/header/widget/header_widget_logo/tool/HeaderLogoTool"),
  [HEADER_WIDGET.prefixType + "CART_TOOL"]: () =>
    import("@components/header/widget/header_widget_cart/tool/HeaderCartTool"),
  [HEADER_WIDGET.prefixType + "LANGUAGE_TOOL"]: () =>
    import("@components/header/widget/header_widget_language/tool/HeaderLanguageTool"),
  [HEADER_WIDGET.prefixType + "CURRENCY_TOOL"]: () =>
    import("@components/header/widget/header_widget_currency/tool/HeaderCurrencyTool"),
  [HEADER_WIDGET.prefixType + "SOCIAL_TOOL"]: () =>
    import("@components/header/widget/header_widget_social/tool/HeaderSocialTool"),
  [HEADER_WIDGET.prefixType + "SEARCH_TOOL"]: () =>
    import("@components/header/widget/header_widget_search/tool/HeaderSearchTool"),
  [HEADER_WIDGET.prefixType + "MEMBER_TOOL"]: () =>
    import("@components/header/widget/header_widget_member/tool/HeaderMemberTool"),
  [HEADER_WIDGET.prefixType + "TOPMENU_TOOL"]: () =>
    import("@components/header/widget/header_widget_topmenu/tool/HeaderTopMenuTool"),
  [HEADER_WIDGET.prefixType + "TEXT_TOOL"]: () =>
    import("@components/header/widget/header_widget_text/tool/HeaderTextTool"),
  [HEADER_WIDGET.prefixType + "QUOTATION_TOOL"]: () =>
    import("@components/header/widget/header_widget_quotation/tool/HeaderQuotationTool"),
  [FOOTER_WIDGET.prefixType + "SOCIAL_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_social/tool/FooterSocialTool"),
  [FOOTER_WIDGET.prefixType + "LOGO_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_logo/tool/FooterLogoTool"),
  [FOOTER_WIDGET.prefixType + "MENU_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_menu/tool/FooterMenuTool"),
  [FOOTER_WIDGET.prefixType + "PARTNER_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_partner/tool/FooterPartnerTool"),
  [FOOTER_WIDGET.prefixType + "SUBSCRIBE_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_subscribe/tool/FooterSubscribeTool"),
  [FOOTER_WIDGET.prefixType + "COPYRIGHT_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_copyrighttext/tool/FooterCopyrightTool"),
  [FOOTER_WIDGET.prefixType + "COPYRIGHT_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_copyrighttext/tool/FooterCopyrightTool"),
  [FOOTER_WIDGET.prefixType + "STATCOUNTER_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_stat/tool/FooterStatTool"),
  [FOOTER_WIDGET.prefixType + "TEXT1_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_text/tool/FooterText1Tool"),
  [FOOTER_WIDGET.prefixType + "TEXT2_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_text/tool/FooterText1Tool"),
  [FOOTER_WIDGET.prefixType + "TEXT3_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_text/tool/FooterText1Tool"),
  [FOOTER_WIDGET.prefixType + "TEXT4_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_text/tool/FooterText1Tool"),
  [FOOTER_WIDGET.prefixType + "FBLIKEBOX_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_facebooklikebox/tool/FooterLikeboxTool"),
  [FOOTER_WIDGET.prefixType + "PAYMENT_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_payment/tool/FooterPaymentTool"),
  [FOOTER_WIDGET.prefixType + "SHIPPING_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_shipping/tool/FooterShippingTool"),
  [FOOTER_WIDGET.prefixType + "TAGS_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_tags/tool/FooterTagsTool"),
  [WIDGET.prefixType + "QUOTATION_FORM_TOOL"]: () =>
    import("@components/dynamic/widget/QuotationForm/tool/QuotationFormTool"),
};

const tools = {
  [WIDGET.prefixType + "IMAGE_GALLERY_TOOL_ACTIVE"]: () =>
    import("@components/dynamic/widget/ImageGallery/tool/ChangeSlide"),
}

const ResizeDots = {
  [WIDGET.prefixType + "TEXT__RESIZEDOT"]: () => import("@components/dynamic/widget/Text/Tools/ResizeDot"),
  [WIDGET.prefixType + "INTERACTIVE__RESIZEDOT"]: () => import("@components/dynamic/widget/Interactive/tool/ResizeDot"),
  [WIDGET.prefixType + "IMAGE__RESIZEDOT"]: () => import("@components/dynamic/widget/Image/tool/ResizeDot"),
  [WIDGET.prefixType + "YOUTUBE__RESIZEDOT"]: () => import("@components/dynamic/widget/Youtube/tool/ResizeDot"),
  [WIDGET.prefixType + "MENU_PRODUCT__RESIZEDOT"]: () => import("@components/dynamic/widget/MenuProduct/tool/MenuProductResize"),
  [WIDGET.prefixType + "BUTTON__RESIZEDOT"]: () => import("@components/dynamic/widget/Button/tool/ResizeDot"),
  [WIDGET.prefixType + "BUTTON_GROUP__RESIZEDOT"]: () => import("@components/dynamic/widget/ButtonGroup/tool/ResizeDot"),
  [WIDGET.prefixType + "HTML__RESIZEDOT"]: () => import("@components/dynamic/widget/Html/tool/ResizeDot"),
  [WIDGET.prefixType + "PRODUCT_CATEGORY__RESIZEDOT"]: () => import("@components/dynamic/widget/ProductCategory/tool/ResizeDot"),
  [WIDGET.prefixType + "TABLE__RESIZEDOT"]: () => import("@components/dynamic/widget/Table/tool/ResizeDot"),
}

const componentsKey = Object.keys(components);
const toolsKey = Object.keys(tools);
const resizeDotKeys = Object.keys(ResizeDots);

export default {
  components: {
    WidgetHover,
    WidgetTool,
    Wrapper,
    // ImageResize,
    LineSeparateResize,
    MapResize,
    Reheight,
    AIToolBadge,
    AIGenerate,
    ...components,
    ...tools,
    ...ResizeDots,
  },
  data() {
    return {
      positionTool: {},
      positionAITool: {},
      isAIToolReady: false,
      aiToolPositionTimer: null,
      topElementPosition: 0,
      typeNotShowTrash : ['Image','Image Gallery','Form','Button','Contact','Line','Album','Youtube','Interactive', 'Social', 'Map'],
      isAIToolActive: false,
      positionAIOptionTool: {},
      isAIGenerateModalVisible: false,
      aiGenerateActionContext: {},
      aiOptionItems: [],
      refs: {
        widgetTool: undefined,
      },
    }
  },
  async created() {
    if(this.isInitPluginMakewebeasyAI === undefined) {
      await this.$store.dispatch("designIframe/ai/checkInitPluginMakewebeasyAI");
    }
  },
  watch: {
    aiOptionContext: {
      immediate: true,
      async handler(context) {
        this.aiOptionItems = await getAIOptionsByContext(context);
      },
    },
    mode() {
      this.$nextTick(function () {
        this.$store.dispatch("designIframe/component/setComponentAction", {
          component_id: this.widgetActive.id,
          type: "WIDGET",
          action: "ACTIVE",
        });
      });
    },
    widgetActive: {
      deep: true,
      handler() {
        const element = document.getElementById("widget-active-frame")
        if(element) {
          this.$nextTick(() => {
            this.topElementPosition = element.offsetTop;
            this.calPositionTool();
          })
        }
      }
    },
    framePosition: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.calPositionTool()
        })
      }
    },
    compMargin:{
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.compMargin;
          
        })
      }
    },
    detectDevice() {
      this.$store.dispatch("designIframe/frame/resetFrame");
    }
  },
  computed: {
    ...mapGetters({
      scrollPosition: "scrollPosition",
      widgetActive: "designIframe/frame/widgetActive",
      gridActive: "designIframe/frame/gridActive",
      parentWidgetActive: "designIframe/frame/parentWidgetActive",
      widgetHover: "designIframe/frame/widgetHover",
      cellHover: "designIframe/frame/cellHover",
      slideSectionActive: "designIframe/frame/slideSectionActive",
      preview: "designIframe/preview",
      components: "designIframe/metadata/components",
      siteComponents: "designIframe/metadata/siteComponents",
      mode: "designIframe/mode",
      detectDevice: "detectDevice",
      elActiveID: "designIframe/component/elActiveID",
      screenWidth: "screenWidth",
      renderTools: "designIframe/frame/renderTools",
      languageEngine: "designIframe/userPreference/languageEngine",
      CONTENT_CONTAINER: "designIframe/metadata/CONTENT_CONTAINER",
      sitePageID: "designIframe/metadata/sitePageID",
      permissionWebsite : "designIframe/permissionWebsite/permissions",
      currencyMain: "designIframe/page/currencyMain",
      isInitPluginMakewebeasyAI : "designIframe/ai/isInitPluginMakewebeasyAI",
    }),
    isWidgetButtonInGroup() {
      if(
        this.components[this.parentWidgetActive.id] &&
        this.components[this.parentWidgetActive.id].type === 'SECTION_WIDGET_BUTTON_GROUP' &&
        this.components[this.widgetActive.id].type === 'SECTION_WIDGET_BUTTON'
        ) {
        //no show Trash //no show duplicate if SECTION_WIDGET_BUTTON
        return true;
      }else {
        return false;
      }
    },
    isSystemWidget() {
      return this.component && this.component.type.includes("SYSTEM_WIDGET") ? true : false
    },
    isHeaderWidget() {
      return this.component && this.component.type.includes("HEADER_WIDGET") ? true : false
    },
    isFooterWidget() {
      return this.component && this.component.type.includes("FOOTER_WIDGET") ? true : false
    },
    isSlideContainerWidget() {
      return this.parent_id && this.parent_id.includes("slc") ? true : false
    },
    ignoreCentralDelete() {
      return Boolean(this.component && [
        'SECTION_WIDGET_TEXT',
        'SECTION_WIDGET_COUNTER',
      ].includes(this.component.type));
    },
    isHeaderWidgetOnTopBar() {
      if (this.isHeaderWidget) {
        let el = document.getElementById('comp-' + this.widgetActive.id)
        let elTop = document.getElementById('top-mb');
        if (el && el.classList.contains('on-topbar') || (!elTop && this.widgetActive.id.includes('HEADER'))) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    resizeable() {
      return ["image", "youtube", "icon"].includes(
        this.widgetTypeShow.toLowerCase()
      );
    },
    getDynamicComponent() {
      if (componentsKey.includes(this.widgetType + "_TOOL")) {
        return this.widgetType + "_TOOL";
      } else {
        return undefined;
      }
    },
    getDynamicComponentTool() {
      if (toolsKey.includes(this.widgetType + "_TOOL_ACTIVE")) {
        if(this.widgetType + "_TOOL_ACTIVE" == 'SECTION_WIDGET_IMAGE_GALLERY_TOOL_ACTIVE' && this.component.style.layout != 3 ) {
          return undefined;
        }
        return this.widgetType + "_TOOL_ACTIVE";
      } else {
        return undefined;
      }
    },
    getDynamicResizeDot() {
      if (resizeDotKeys.includes(`${this.widgetType}__RESIZEDOT`)) {
        return `${this.widgetType}__RESIZEDOT`;
      } else {
        return undefined;
      }
    },
    // CELL
    parent_id() {
      return Object.keys(this.components).find((key) =>
        (this.components[key].componentsID && this.components[key].componentsID.includes(this.widgetActive.id)) ||
        (this.components[key].componentsIDHover && this.components[key].componentsIDHover.includes(this.widgetActive.id))
      );
    },
    // GRID
    grid_id() {
      return this.parent_id && Object.keys(this.components).find((key) =>
        this.components[key].componentsID && this.components[key].componentsID.includes(this.parent_id)
      );
    },
    // PARENT (SECTION OR WIDGET)
    section_id() {
      return this.grid_id && Object.keys(this.components).find((key) =>
        this.components[key].componentsID && this.components[key].componentsID.includes(this.grid_id)
      );
    },
    component() {
      if (this.widgetActive.id && (this.widgetActive.id.includes('HEADER') || this.widgetActive.id && this.widgetActive.id.includes('FOOTER'))) {
        return this.siteComponents[this.widgetActive.id];
      } else {
        return this.components[this.widgetActive.id];
      }
    },
    componentStyle() {
      return this.component.style;
    },
    widgetType() {
      return this.component && this.component.type;
    },
    indexShowWidget(){
      if (!this.widgetActive.id || !this.components) return '';
      let atv_have_parent = this.components && this.parentWidgetActive && this.components[this.parentWidgetActive.id];
      if (atv_have_parent && atv_have_parent.type === 'SECTION_WIDGET_BUTTON_GROUP') {
        return ' ' + (atv_have_parent.componentsID.indexOf(this.widgetActive.id) + 1);
      }
      return '';
    },
    widgetTypeShow() {
      if(!this.widgetType) return "";
      let type = "";
      switch (this.widgetType) {
        case "SECTION_WIDGET_BUTTON":
          type = "Button" + (this.indexShowWidget);
          break;
        case "SECTION_WIDGET_TAB":
          type = "Tabs";
          break;
        case "SECTION_WIDGET_LINE_SEPARATE":
          type = "Line";
          break;
        case "SECTION_WIDGET_CONTENT":
          type = "Blog";
          break;
        case "HEADER_WIDGET_MENU":
          type = "Header Menu";
          break;
        case "HEADER_WIDGET_LOGO":
          type = "Logo";
          break;
        case "HEADER_WIDGET_MEMBER":
          type = "Member";
          break;
        case "HEADER_WIDGET_SOCIAL":
          type = "Social";
          break;
        case "HEADER_WIDGET_LANGUAGE":
          type = "Language";
          break;
        case "HEADER_WIDGET_CURRENCY":
          type = "Currency";
          break;
        case "HEADER_WIDGET_SEARCH":
          type = "Search";
          break;
        case "HEADER_WIDGET_TEXT":
          type = "Text";
          break;
        case "HEADER_WIDGET_TOPMENU":
          type = "Top Menu";
          break;
        case "HEADER_WIDGET_CART":
          type = "Cart";
          break;
        case "HEADER_WIDGET_QUOTATION":
          type = "Quote";
          break;
        case "FOOTER_WIDGET_MENU":
          type = "Footer Menu";
          break;
        case "FOOTER_WIDGET_LOGO":
          type = "Logo";
          break;
        case "FOOTER_WIDGET_SUBSCRIBE":
          type = "Subscribe";
          break;
        case "FOOTER_WIDGET_SOCIAL":
          type = "Social";
          break;
        case "FOOTER_WIDGET_PARTNER":
          type = "Logo Partner";
          break;
        case "FOOTER_WIDGET_COPYRIGHT":
          type = "Copyright";
          break;
        case "FOOTER_WIDGET_STATCOUNTER":
          type = "Stat Counter";
          break;
        case "FOOTER_WIDGET_TEXT1":
          type = "Text";
          break;
        case "FOOTER_WIDGET_TEXT2":
          type = "Text";
          break;
        case "FOOTER_WIDGET_TEXT3":
          type = "Text";
          break;
        case "FOOTER_WIDGET_TEXT4":
          type = "Text";
          break;
        case "FOOTER_WIDGET_FBLIKEBOX":
          type = "Facebook LikeBox";
          break;
        case "FOOTER_WIDGET_PAYMENT":
          type = "Payment";
          break;
        case "FOOTER_WIDGET_SHIPPING":
          type = "Shipping";
          break;
        case "FOOTER_WIDGET_TAGS":
          type = "Tags";
          break;
        default:
          type = this.widgetType.replace(WIDGET.prefixType, "")
          break;
      }
      type = this.$helper.text.capitalize(type);
      return this.$te(`engine.floatframeTool.floatframeActive.lbl${type}`, this.languageEngine) ? this.$t(`engine.floatframeTool.floatframeActive.lbl${type}`, this.languageEngine) : type;
    },
    aiOptionContext() {
      return getContextByWidgetType(this.widgetType);
    },
    checkShowReHeight() {
      switch (this.widgetType) {
        case "SECTION_WIDGET_IMAGE_GALLERY":
          return this.component.style.layout == 3 && this.component.style.crop != 'original' && this.detectDevice != 'mobile' ? true : false;
        default:
          return false;
      }
    },
    // Elements
    elemWidgetActive() {
      if (this.widgetActive.id == 'HEADER_WIDGET_MENU' && this.siteComponents.HEADER.style.layout == '05') {  
        // Header widget menu ใน Header layout 05 จะแบ่งออกเป็น 3 ก้อนอยู่แยกกัน เลยต้องคำนวน position floatframe ใหม่
        let menuRow1 = document.getElementsByClassName('hmenu-row-1')[0]
        let menuRow2 = document.getElementsByClassName('hmenu-row-2')[0]
        let compHeaderMenu = document.getElementById('comp-HEADER_WIDGET_MENU')
        let menuRow2PosBottom = menuRow2 ? menuRow2.getBoundingClientRect().bottom : 0
        let menuRow1PosLeft = menuRow1 ? menuRow1.getBoundingClientRect().left : 0
        let menuRow1Width = menuRow1 ? menuRow1.offsetWidth : 0
        let menuRow2Width = menuRow2 ? menuRow2.offsetWidth : 0
        let headerMenuPosTop = compHeaderMenu ? compHeaderMenu.getBoundingClientRect().top : 0
        return {
          params: {
            position: {
              width: Math.max(menuRow1Width, menuRow2Width) + 'px',
              height: menuRow2PosBottom > 0 ? (menuRow2PosBottom - headerMenuPosTop) + 'px' : this.widgetActive.position.height,
              top: this.widgetActive.position.top,
              left: menuRow1PosLeft + 'px'
            }
          }
        };
      } else {
        return {
          params: {
            position: {
              width: this.widgetActive.position.width,
              height: this.widgetActive.position.height,
              top: this.widgetActive.position.top,
              left: this.widgetActive.position.left,
            }
          }
        };
      }
    },
    compMargin() {
        return this.component && this.component.style && this.component.style.marginTop <= 88 ?  this.component.style.marginTop : 30  || 30;
    },
    isOverScroll() {
        const diff = this.scrollPosition - (this.topElementPosition - this.compMargin ) ;
        if (diff >= -10 || this.isHeaderWidgetOnTopBar) {
          return true;
        } else {
          return false;
        }
    },
    HEADER() {
      return this.siteComponents.HEADER;
    },
    getMainPage() {
      const mainPageID =
        this.siteComponents &&
        this.siteComponents.MAIN_PAGE &&
        this.siteComponents.MAIN_PAGE.properties &&
        this.siteComponents.MAIN_PAGE.properties.pageID;
      return mainPageID;
    },
    oversection() {
      return (
        this.sitePageID == this.getMainPage && this.HEADER.style.isEnableOverSection
      );
    },
    indexSection() {
      return this.section_id && this.CONTENT_CONTAINER.componentsID.indexOf(this.section_id);
    },
    isFirstSection() {
      return this.section_id && this.indexSection == 0;
    },
    attr() {
      if(this.isOverScroll) {
        return "marginBottom"
      } else {
        return "marginTop"
      }
    },
    cellComponent() {
      return this.parent_id && this.components[this.parent_id]
    },
    cellWidth() {
      if (!this.parent_id) return 0;
      let id = "comp-" + this.parent_id;
      const target = document.getElementById(id);

      let rect = target ? target.getBoundingClientRect() : {};
      let width = rect.width;
      let cellPaddingLeft =
        this.components[this.parent_id].style.paddingLeft;
      let cellPaddingRight =
        this.components[this.parent_id].style.paddingRight;

      width = Math.floor(width - (cellPaddingLeft + cellPaddingRight));

      return {width,cellPaddingLeft,cellPaddingRight}
    },
    indexCell() {
      if (this.components[this.grid_id]) {
        if (this.detectDevice == 'mobile') {
          return this.components[this.grid_id].componentsIDMobile.indexOf(this.parent_id);
        } else {
          return this.components[this.grid_id].componentsID.indexOf(this.parent_id);
        }
      } else {
        return 0;
      }
    },
    indexWidget() {
      return this.cellComponent && this.cellComponent.componentsID.indexOf(this.widgetActive.id);
    },
    isFirstIndex() {
      return this.indexWidget == 0;
    },
    widgetWidth() {
      if (!this.component) return 0;
      let id = "comp-" + this.component.id;
      const target = document.getElementById(id);

      let rect = target ? target.getBoundingClientRect() : {};
      let width = rect.width;

      return Math.floor(width)
    },
    isHaveTopGap() {
      if (!this.component) return 0
      let id = `resize-margin-top-${this.component.id}`;
      const target = document.getElementById(id);

      let rect = target ? target.getBoundingClientRect() : {};
      let height = rect.height;

      return height
    },
    isWidgetOverlap() {
      return  this.component && !this.isHeaderWidget && !this.isFooterWidget && this.widgetWidth >= this.cellWidth.width && this.cellComponent.style.paddingTop == 0 && this.cellComponent.style.paddingLeft == 0 && this.isFirstIndex && this.isHaveTopGap <= 1
    },
    framePosition() {
      return this.widgetActive.position
    },
    hideTool() {
      return this.detectDevice !== "desktop" && ((this.isHeaderWidget && this.widgetType != 'HEADER_WIDGET_TEXT') || (this.widgetTypeShow ==  'Image Gallery' || this.widgetTypeShow == 'Album' || this.widgetTypeShow == 'Blog' || this.widgetTypeShow == 'Product' || this.widgetTypeShow == 'Faq' || this.widgetTypeShow == 'Product Brand' || this.widgetTypeShow == 'Coupon' || this.widgetType == 'SECTION_WIDGET_PRODUCT_CATEGORY' || this.widgetType == 'SECTION_WIDGET_TABLE'))
    },
    isParentGrid() {
      if (this.gridActive.id) {
        const parentGridIds = findParentComponent(this.components, this.gridActive.id);
        return parentGridIds.indexOf(this.widgetActive.id) !== -1;
      }
      return false;
    },
    isActiveWidget() {
      return this.isParentGrid
    },
    isLabelDisabled() {
      return this.isActiveWidget
    },
    isLabelActive() {
      return !this.isActiveWidget
    },
    permissionDesignAI() {
      return this.permissionWebsite.isDesignAI == 1;
    },
    isEnableAI() {
      if (!this.widgetType) return false;
      return this.widgetType.includes('TEXT') || 
             this.widgetType === 'SECTION_WIDGET_TEXT' ||
             this.widgetType === 'SYSTEM_WIDGET_TEXT';
    },
    aiToolBorderObject() {
      return this.isAIToolActive 
        ? { border: '1px solid #FFF !important' }
        : { border: '1px solid #ffffff !important' };
    },
    aiToolShadowObject() {
      return {
        shadow: '-2px 4px 16px 0 rgba(40, 190, 227, 0.15), 2px -4px 16px 0 rgba(238, 70, 188, 0.15)'
      };
    },
    aiToolBackgroundObject() {
      return this.isAIToolActive
        ? { background: 'linear-gradient(61deg, #28BEE3 0%, #7A5AF8 49.73%, #EE46BC 99.45%)' }
        : {};
    },
    aiToolBadgeStyle() {
      if (this.isAIToolActive && this.aiToolBackgroundObject.background) {
        return {
          background: this.aiToolBackgroundObject.background
        };
      }
      return {};
    },
    aiToolBadgeComputedStyle() {
      const style = {
        visibility: this.isAIToolReady ? 'visible' : 'hidden',
      };
      if (this.positionAITool.left) style.left = this.positionAITool.left;
      if (this.positionAITool.top) style.top = this.positionAITool.top;
      if (this.isAIToolActive && this.aiToolBackgroundObject.background) {
        style.background = this.aiToolBackgroundObject.background;
      }
      return style;
    },
    getWidgetOriginalText() {
      if (!this.component || !this.component.data) return '';
      // Try to extract text content from the widget
      return this.component.data.replace(/<[^>]*>?/g, '') || '';
    },
    permissionCurrency() {
      return this.currencyMain == 'THB'
    },
    isShowAITool() {
      return this.isInitPluginMakewebeasyAI && this.permissionCurrency
    },
  },
  methods: {
    translatePixelToPct({ translate, scale = 0, frame }) {
      return (translate / (scale - frame)) * 100;
    },
    translatePctToPixel({ pct, scale = 0, frame }) {
      return (pct / 100) * (scale - frame);
    },
    callbackResize() {
      this.resetWidgetToolPosition();
    },
    removeWidget() {
      // let isExecuted = confirm("Are you sure to delete this widget?");
      // if (isExecuted) {

      this.$store.dispatch("designIframe/component/removeComponent", {
        id: this.widgetActive.id,
      });

      this.$store.dispatch("designIframe/frame/setSlideWidgetActive", {})
      this.$store.dispatch("designIframe/frame/setWidgetActive", {})

      if (this.parent_id && this.parent_id.includes("slc")) {
        this.$store.dispatch("designIframe/frame/setSlideSectionActive", {
          component_id: this.slideSectionActive.id,
          index: this.slideSectionActive.index
        });
        this.$store.dispatch("designIframe/component/elActive", {
          elementID: ["component", this.parent_id],
        });
        this.$store.dispatch("designIframe/frame/setSlideContainerActive", {
          component_id: this.parent_id,
        });
        this.$store.dispatch("designIframe/frame/setSlideWidgetActive", {})
      }
      // }
    },
    resetWidgetToolPosition() {
      this.$nextTick(function () {
        this.$store.dispatch("designIframe/component/setComponentAction", {
          component_id: this.widgetActive.id,
          type: "WIDGET",
          action: "ACTIVE",
        });
      });
    },
    calPositionTool() {
      let activeFrame = document.getElementById('widget-active-frame')
      let toolEl = document.getElementById('widget-tool-badge')

      if (activeFrame && toolEl) {
        let activeFrameWidth = activeFrame.getBoundingClientRect().width
        let toolPosRight= toolEl.getBoundingClientRect().right
        if (toolPosRight > this.screenWidth) {
            this.positionTool = {
              right: 0 - activeFrameWidth / 4 + 'px'
            }
        } else {
            this.positionTool = {}
        }
      }
      
      // Calculate AI Tool position next to WidgetTool badge
      // Wait for main badge width to stabilize (icons load async)
      if (this.isEnableAI && this.permissionDesignAI) {
        this.isAIToolReady = false
        this.waitForStableBadgeWidth()
      } else {
        clearTimeout(this.aiToolPositionTimer)
        this.isAIToolReady = false
        this.positionAITool = {}
        this.positionAIOptionTool = {}
      }
    },
    /**
     * Poll widget-tool-badge width until stable, then position AI badge.
     * Max 10 attempts, 80ms apart.
     */
    waitForStableBadgeWidth(lastWidth = 0, attempt = 0) {
      clearTimeout(this.aiToolPositionTimer)
      if (attempt >= 15) {
        this.applyAIToolPosition()
        return
      }
      this.aiToolPositionTimer = setTimeout(() => {
        let badge = document.getElementById('widget-tool-badge')
        if (!badge) {
          this.waitForStableBadgeWidth(0, attempt + 1)
          return
        }
        let currentWidth = badge.getBoundingClientRect().width
        if (currentWidth > 0 && currentWidth === lastWidth) {
          this.applyAIToolPosition()
        } else {
          this.waitForStableBadgeWidth(currentWidth, attempt + 1)
        }
      }, 30)
    },
    applyAIToolPosition() {
      let $wrapper = document.getElementById('widget-active-frame')
      let $mainBadge = document.getElementById('widget-tool-badge')

      if ($wrapper && $mainBadge) {
        let wrapperRect = $wrapper.getBoundingClientRect()
        let mainBadgeRect = $mainBadge.getBoundingClientRect()
        let gap = 8

        let aiBadge = document.getElementById('widget-ai-tool-badge')
        let aiBadgeWidth = aiBadge ? aiBadge.getBoundingClientRect().width : 52
        let left = (mainBadgeRect.left - wrapperRect.left) - gap - aiBadgeWidth
        let top = mainBadgeRect.top - wrapperRect.top

        this.positionAITool = {
          left: `${left}px`,
          top: `${top}px`,
        }
        this.isAIToolReady = true
        if (this.isAIToolActive) {
          this.calculatePositionAIOptionTool()
        }
      }
    },
    goTo(type) {
      if (!this.preview) {
        switch (type) {
          case "section": {
            var compID = this.section_id;

            this.$store.dispatch("designIframe/frame/setSectionActive", {
              component_id: compID,
              name: compID,
            });
            this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
            this.$store.dispatch("designIframe/frame/setCellActive", {});
            this.$store.dispatch("designIframe/frame/setCellHover", {});
            this.$store.dispatch("designIframe/frame/setWidgetActive", {});
            this.$store.dispatch("designIframe/frame/setWidgetHover", {});
            this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
            this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});

            let noneSetting = false;
            SECTION_TYPE_NONE_SETTING.find((type) => {
              Object.entries(this.components).forEach((item) => {
                if (type === item[1].type && item[1].id === this.section_id) {
                  noneSetting = true;
                }
              })
            });
            if (noneSetting) {
              this.$store.dispatch("design/component/elActive", {});
            } else {
              this.$store.dispatch("design/component/elActive", {
                elementID: ["component", compID],
              });
            }
            break;
          }
          case "cell": {
            
            if (this.parent_id && this.grid_id) {
              this.$store.dispatch("designIframe/frame/setSectionActive", {
                component_id: this.section_id,
                name: this.section_id,
              });
              this.$store.dispatch("designIframe/component/elActive", {
                elementID: ["component", this.parent_id],
              });
              this.$store.dispatch("designIframe/frame/setCellActive", {
                component_id: this.parent_id,
                parent_id: this.grid_id,
              });
            }
            this.$store.dispatch("designIframe/frame/setSlideSectionHover", {});
            this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
            this.$store.dispatch("designIframe/frame/setSlideContainerHover", {})
            this.$store.dispatch("designIframe/frame/setSlideContainerActive", {})
            this.$store.dispatch("designIframe/frame/setWidgetHover", {})
            this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
            this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
            this.$store.dispatch("designIframe/frame/setSectionHover", {});
            break;
          }
          case "grid": {
            
            if (this.parent_id && this.grid_id) {
              this.$store.dispatch("designIframe/frame/setSectionActive", {
                component_id: this.section_id,
                name: this.section_id,
              });
              this.$store.dispatch("designIframe/component/elActive", {
                elementID: ["component", this.parent_id],
              });
              this.$store.dispatch("designIframe/frame/setCellActive", {
                component_id: this.parent_id,
                parent_id: this.grid_id,
              });
            }
            this.$store.dispatch("designIframe/frame/setSlideSectionHover", {});
            this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
            this.$store.dispatch("designIframe/frame/setSlideContainerHover", {})
            this.$store.dispatch("designIframe/frame/setSlideContainerActive", {})
            this.$store.dispatch("designIframe/frame/setWidgetHover", {})
            this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
            this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
            this.$store.dispatch("designIframe/frame/setSectionHover", {});
            break;
          }
          default:
            break;
        }
      }
    },
    duplicateWidget() {
      this.$store.commit("designIframe/setStatePath", {
        value: {
          widgetID: this.widgetActive.id,
        },
        path: "/component/addComponent/widget",
      });

      this.$store.dispatch("designIframe/component/duplicateComponent", {
        parent_id: this.parent_id,
        component_id: this.widgetActive.id,
      });

      this.$store.dispatch("designIframe/snapshot/genSnapshot");
    },
    openAITool(event) {
      if (event) {
        event.stopPropagation();
      }
      
      // Toggle AI tool active state
      this.isAIToolActive = !this.isAIToolActive;
      
      if (this.isAIToolActive) {
        // Calculate dropdown position when opening
        this.$nextTick(() => {
          this.calculatePositionAIOptionTool();
        });
        
        // Close dropdown when clicking outside - use setTimeout to avoid immediate trigger
        setTimeout(() => {
          document.addEventListener('click', this.handleClickOutside, true);
          document.addEventListener('mousedown', this.handleClickOutside, true);
        }, 100);
      } else {
        // Remove click outside listener when closing
        this.isAIGenerateModalVisible = false;
        document.removeEventListener('click', this.handleClickOutside, true);
        document.removeEventListener('mousedown', this.handleClickOutside, true);
      }
    },
    /**
     * Calculate AI Option Dropdown position relative to Wrapper (#widget-active-frame)
     * Badge → find its position inside Wrapper → place dropdown below it
     */
    calculatePositionAIOptionTool() {
      this.$nextTick(() => {
        const $wrapper = document.getElementById('widget-active-frame');
        const $badge = document.getElementById('widget-ai-tool-badge');
        
        if (!$wrapper || !$badge) {
          this.positionAIOptionTool = {};
          return;
        }

        const wrapperRect = $wrapper.getBoundingClientRect();
        const badgeRect = $badge.getBoundingClientRect();

        const gap = 8;
        const dropdownW = 276; // width from AIOption.vue style

        // Badge position relative to Wrapper
        const badgeBottom = badgeRect.bottom - wrapperRect.top;
        const badgeRight = badgeRect.right - wrapperRect.left;

        // Place below badge, aligned to badge right edge
        let top = badgeBottom + gap;
        let left = badgeRight - dropdownW;

        // Clamp to viewport
        const win_r = window.innerWidth;
        const win_b = window.innerHeight;

        // Don't go off right edge
        if (left + wrapperRect.left + dropdownW > win_r - gap) {
          left = (win_r - gap - dropdownW) - wrapperRect.left;
        }
        // Don't go off left edge
        if (left + wrapperRect.left < gap) {
          left = gap - wrapperRect.left;
        }
        // Don't go off bottom (flip above badge)
        if (badgeRect.bottom + gap + 300 > win_b) { // 300 = estimated dropdown height
          top = (badgeRect.top - wrapperRect.top) - gap - 300;
          if (top < gap - wrapperRect.top) {
            top = gap - wrapperRect.top;
          }
        }

        this.positionAIOptionTool = {
          top: `${top}px`,
          left: `${left}px`,
        };
      });
    },
    handleClickOutside(event) {
      const aiToolBadge = document.getElementById('widget-ai-tool-badge');
      const aiOptionDropdown = event.target.closest('.ai-option-dropdown');
      const aiOptionContainer = document.getElementById('ai-option-container');
      const aiGenerateModal = event.target.closest('.ai-generate-modal');
      const aiSubmenu = event.target.closest('.ai-submenu');
      const aiSubmenuItem = event.target.closest('.ai-submenu-item');
      const aiOptionItem = event.target.closest('.ai-option-item');
      // Don't close if clicking inside ModalAlert (b-modal overlay/dialog)
      const bvModalContent = event.target.closest('.modal-content');
      const bvModalBackdrop = event.target.closest('.modal-backdrop');
      
      // Don't close if clicking inside AI tool badge, dropdown, submenu, generate modal, modal alert, or any menu item
      if (aiToolBadge && 
          !aiToolBadge.contains(event.target) && 
          !aiOptionDropdown && 
          !aiSubmenu &&
          !aiSubmenuItem &&
          !aiOptionItem &&
          !aiGenerateModal &&
          !bvModalContent &&
          !bvModalBackdrop &&
          (!aiOptionContainer || !aiOptionContainer.contains(event.target))) {
        // When AIGenerate modal is visible, use handleClose to show confirmation if needed (same as X button)
        if (this.isAIGenerateModalVisible && this.$refs.aiGenerateModal) {
          event.stopPropagation();
          event.preventDefault();
          this.$refs.aiGenerateModal.handleClose();
          // Listeners removed in closeAIGenerateModal when user confirms (or when no confirmation needed)
        } else {
          this.isAIGenerateModalVisible = false;
          this.isAIToolActive = false;
          document.removeEventListener('click', this.handleClickOutside, true);
          document.removeEventListener('mousedown', this.handleClickOutside, true);
        }
      }
    },
    handleAIOptionClick(option) {
      // For non-submenu options (create, shorten, expand), open generate modal directly
      this.openAIGenerateModal({
        parent: option,
        subOption: null
      });
    },
    handleAISubmenuClick(payload) {
      // For submenu options (tone, translate), open generate modal with sub-option context
      this.openAIGenerateModal(payload);
    },
    openAIGenerateModal(actionContext) {
      this.aiGenerateActionContext = actionContext;
      this.isAIGenerateModalVisible = true;

      // Reset stored position so it recalculates
      this.$store.dispatch('designIframe/frame/setWidgetActiveAIGenerateModalPosition', { 
        position: { top: undefined, left: undefined, right: undefined } 
      });

      this.$nextTick(() => {
        this.reAIGenerateModal();
      });
    },
    /**
     * Calculate AI Generate Modal position — same pattern as Quill.vue reToolbar()
     * 
     * container = #widget-active-frame (Wrapper)   — like .mwe-texteditor-container
     * tool      = AIGenerate                   — like Toolbar
     */
    reAIGenerateModal() {
      const $container = document.getElementById('widget-active-frame');
      const $tool = this.$refs.aiGenerateModal && this.$refs.aiGenerateModal.$el ? this.$refs.aiGenerateModal.$el : null;

      if (!$container || !$tool) return;

      const rectContainer = $container.getBoundingClientRect();
      const rectTool = $tool.getBoundingClientRect();

      const win_t = 0;
      const win_b = window.innerHeight;
      const win_l = 0;
      const win_r = window.innerWidth;

      const container_w = rectContainer.width;
      const container_h = rectContainer.height;
      const container_t = rectContainer.top;
      const container_b = rectContainer.bottom;
      const container_l = rectContainer.left;
      const container_r = rectContainer.right;

      const tool_w = rectTool.width || 500;
      const tool_h = rectTool.height || 800;

      const space_l = container_l;
      const space_r = win_r - container_r;
      const space_t = container_t;
      const space_b = win_b - container_b;

      const gap_x = 16;
      const gap_y = 16;

      let position = {};

      const normalizeTop = (value) => {
        const topMin = (win_t + gap_y) - container_t;
        const topMax = (win_b - gap_y - tool_h) - container_t;
        return Math.min(Math.max(value, topMin), topMax);
      };
      const normalizeLeft = (value) => {
        const leftMin = (win_l + gap_x) - container_l;
        const leftMax = (win_r - gap_x - tool_w) - container_l;
        return Math.min(Math.max(value, leftMin), leftMax);
      };

      if (space_r > tool_w + gap_x) {
        let left = 0 + container_w + gap_x; // right outer
        let top = normalizeTop(0); // top inner
        position.top = `${top}px`;
        position.left = `${left}px`;
      } else if (space_l > tool_w + gap_x) {
        let left = 0 - gap_x - tool_w; // left outer
        let top = normalizeTop(0); // top inner
        position.top = `${top}px`;
        position.left = `${left}px`;
      } else {
        if (space_r >= space_l) {
          let left = normalizeLeft(0 + container_w + gap_x);
          position.left = `${left}px`;
        } else {
          let left = normalizeLeft(0 - gap_x - tool_w);
          position.left = `${left}px`;
        }
        if (space_t >= space_b) {
          let top = normalizeTop(0 - gap_y - tool_h);
          position.top = `${top}px`;
        } else {
          let top = normalizeTop(0 + gap_y + container_h);
          position.top = `${top}px`;
        }
      }

      this.$store.dispatch('designIframe/frame/setWidgetActiveAIGenerateModalPosition', { position });
    },
    closeAIGenerateModal() {
      this.isAIGenerateModalVisible = false;
      this.aiGenerateActionContext = {};
      this.openAITool(false);
      // Keep position in store for next time modal opens
    },
    handleAIApply(payload) {
      if (!payload || !payload.text) return;

      const texteditor = this.$store.getters['designIframe/texteditor/texteditor'];
      const widgetId = this.widgetActive.id;
      const isEditorActive = texteditor.active && texteditor.editor && texteditor.original.targetID === `texteditor-${widgetId}`;
      const newText = payload.text;

      if (isEditorActive) {
        // Editor is active: replace text only, keep existing HTML formatting
        const editor = texteditor.editor;
        const length = editor.getLength();
        // Select all text then delete, insert new text — Quill keeps first line's format
        editor.deleteText(0, length);
        editor.insertText(0, newText);
        // Quill will fire onEditorChange → onChange → callback automatically
      } else {
        // Editor is NOT active: replace text inside existing HTML, keep tags
        if (this.component && this.component.data) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = this.component.data;
          const walker = document.createTreeWalker(tempDiv, NodeFilter.SHOW_TEXT);
          const firstTextNode = walker.nextNode();
          if (firstTextNode) {
            firstTextNode.textContent = newText;
            let node;
            while ((node = walker.nextNode())) {
              node.textContent = '';
            }
          }
          this.component.data = tempDiv.innerHTML;
        } else if (this.component) {
          this.component.data = newText;
        }
      }

      // Generate snapshot for undo/redo
      this.$store.dispatch('designIframe/snapshot/genSnapshot');

      // Close modal and clean up
      // this.closeAIGenerateModal();
      // this.isAIToolActive = false;
      // document.removeEventListener('click', this.handleClickOutside, true);
      // document.removeEventListener('mousedown', this.handleClickOutside, true);
    },
    handleAIModalPositionChange(newPosition) {
      this.$store.dispatch('designIframe/frame/setWidgetActiveAIGenerateModalPosition', { 
        position: { top: newPosition.top, left: newPosition.left } 
      });
    },
  },
  mounted() {
    this.refs.widgetTool = this.$refs.widgetTool;
    this.$nextTick(() => {
      this.calPositionTool();
    });
  },
};
</script>

<style scoped>
.badge {
  background: #ffffff !important;
  border: 1px solid #dee3e6 !important;
  font-weight: normal;
}

/* AI Generate Modal — same pattern as .tool in Quill.vue */
.ai-generate-modal-tool {
  z-index: 10001;
  position: absolute;
  pointer-events: all;
}
</style>